// externals
import * as React from 'react';

export interface IGTPRulesTriggerProps {
    onOpen: () => void;
    linkText?: string;
}

const GTPRulesTrigger: React.FC<IGTPRulesTriggerProps> = ({ onOpen, linkText = 'Program Rules and Eligibility' }) => (
    <a className="btn-link link primary-link" id="dr_trade_subaru_rules_link" onClick={onOpen}>
        {linkText}
    </a>
);

export default GTPRulesTrigger;
